import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';

type FireBaseRaffleTransaction = {
  name: string;
  tickets: number;
};
type FireBaseRaffle = {
  transactions: {
    [key: string]: FireBaseRaffleTransaction;
  };
};
interface Props {
  allEntries: {
    brisBricks202012MemberRaffle: FireBaseRaffle;
    brisBricks202012PublicRaffle: FireBaseRaffle;
  };
}
const Entries: React.FC<Props> = (props) => {
  const { allEntries } = props;
  const [publicRaffleNames, setPublicRaffleNames] = useState<string[]>([]);
  const [memberRaffleNames, setMemberRaffleNames] = useState<string[]>([]);
  useEffect(() => {
    if (allEntries) {
      // console.log(allEntries);
      let memberNames: string[] = [];
      let publicNames: string[] = [];

      Object.keys(allEntries.brisBricks202012MemberRaffle.transactions).forEach((v) => {
        // console.log(v);
        memberNames = [
          ...memberNames,
          ...Array.from(
            Array(allEntries.brisBricks202012MemberRaffle.transactions[v].tickets).keys()
          ).map(() => allEntries.brisBricks202012MemberRaffle.transactions[v].name),
        ];
      });
      Object.keys(allEntries.brisBricks202012PublicRaffle.transactions).forEach((v) => {
        publicNames = [
          ...publicNames,
          ...Array.from(
            Array(allEntries.brisBricks202012PublicRaffle.transactions[v].tickets).keys()
          ).map(() => allEntries.brisBricks202012PublicRaffle.transactions[v].name),
        ];
      });
      // console.log(memberNames);
      setMemberRaffleNames(memberNames);
      setPublicRaffleNames(publicNames);
    }
  }, [allEntries]);
  return (
    <div style={{ marginTop: 20 }}>
      <Paper style={{ padding: 20 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ paddingBottom: 20 }}>
              Member Raffle Names
            </Typography>
          </Grid>
          {memberRaffleNames.map((v, i) => (
            <Grid key={i} item xs={12}>
              <Typography variant='body1'>{v}</Typography>
            </Grid>
          ))}
          <Grid item xs={12} style={{ paddingTop: 20, paddingBottom: 20 }}>
            <Typography variant='h4'>Public Raffle Names</Typography>
          </Grid>
          {publicRaffleNames.map((v, i) => (
            <Grid key={i} item xs={12}>
              <Typography variant='body1'>{v}</Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </div>
  );
};

export default Entries;
